import { render } from "./CardTransactions.vue?vue&type=template&id=2c695228"
import script from "./CardTransactions.vue?vue&type=script&lang=js"
export * from "./CardTransactions.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__